import BasePlayer from 'services/sports/default/base-player';
import {getDefaultExposure} from 'helpers/player-helper';
import Action from 'actions';
import Const from 'constants';

export default class Player extends BasePlayer {
    resetSettings({incomingValues: {dispatch}}) {
        const {
            playersData: {players},
            userPointsType,
        } = Action.getState();

        const playersUserPoints = [];
        const playersExposure = [];
        const playersLineGroup = [];
        const playersPpLine = [];

        players.getAllAsArr().map((player) => {
            playersUserPoints.push({
                playerId: player.playerId,
                name: player.name,
                userPoints: this.exec('applySympathyToPoints', {
                    player,
                    points: player[userPointsType.getUserPointsType()],
                }),
            });

            playersExposure.push({
                playerId: player.playerId,
                exposureMin: getDefaultExposure('min'),
                exposureMax: getDefaultExposure('max'),
            });

            playersLineGroup.push({
                playerId: player.playerId,
                userLineGroup: player.lineGroup,
            });

            playersPpLine.push({
                playerId: player.playerId,
                userPpLine: player.ppLine,
            });
        });

        dispatch(Action.do('resetExcludePlayersByRange'));
        dispatch(Action.set('PlayersExposure', playersExposure));
        dispatch(Action.set('PlayersPPLine', playersPpLine));
        dispatch(Action.set('PlayersLineGroup', playersLineGroup));
        dispatch(Action.set('UserPoints', playersUserPoints, Const.FLEX_MODE, false, {countPlayers: false}));

        return true;
    }

    resetSettings_ShowDown({incomingValues: {dispatch, modes = [Const.CAPTAIN_MODE, Const.FLEX_MODE]}}) {
        const {
            playersData: {players},
            userPointsType,
        } = Action.getState();

        const userPointsByModes = {};
        const exposure = [];
        const playersLineGroup = [];
        const playersPpLine = [];

        players.getAllAsArr().map((player) => {
            modes.map((mode) => {
                userPointsByModes[mode] ??= [];
                userPointsByModes[mode].push({
                    playerId: player.getId(),
                    userPoints: this.exec('applySympathyToPoints', {
                        player,
                        points: player.getPropValueOfMode(userPointsType.getUserPointsType(), mode),
                        mode,
                    }),
                });
            });

            modes.map((mode) => {
                exposure.push({
                    playerId: player.getId(),
                    exposureMin: getDefaultExposure('min'),
                    exposureMax: getDefaultExposure('max'),
                    mode,
                });
            });

            playersLineGroup.push({
                playerId: player.playerId,
                name: player.name,
                userLineGroup: player.lineGroup,
            });

            playersPpLine.push({
                playerId: player.playerId,
                name: player.name,
                userPpLine: player.ppLine,
            });
        });

        dispatch(Action.do('resetExcludePlayersByRange'));
        dispatch(Action.set('PlayersPPLine', playersPpLine));
        dispatch(Action.set('PlayersLineGroup', playersLineGroup));
        dispatch(Action.set('PlayersExposure', exposure));

        modes.map((mode) => {
            dispatch(Action.set('UserPoints', userPointsByModes[mode], mode, false, {countPlayers: false}));
        });

        return true;
    }

    loadExtraPlayerDataFromStore({incomingValues: {dispatch, data}}) {
        if (data.hasOwnProperty('lineGroups')) {
            dispatch(Action.set('LineGroupsFromStorage', data.lineGroups));
        }
    }
}
